var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 56,
    viewBox: "0 0 80 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H80V56C48.7581 56 31.2419 56 0 56V0Z",
    fill: "#1F72CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3443 19.4297L6.85938 35.9937H15.8199L16.9308 33.3527H19.4699L20.5808 35.9937H30.4438V33.978L31.3227 35.9937H36.4246L37.3035 33.9354V35.9937H57.816L60.3102 33.4213L62.6457 35.9937L73.1813 36.015L65.6727 27.7579L73.1813 19.4297H62.8091L60.3811 21.9546L58.1191 19.4297H35.8043L33.8881 23.705L31.9269 19.4297H22.9851V21.3768L21.9904 19.4297H14.3443ZM44.9756 21.7812H56.7548L60.3575 25.6729L64.0764 21.7812H67.6791L62.2051 27.755L67.6791 33.66H63.913L60.3103 29.7232L56.5725 33.66H44.9756V21.7812ZM47.8848 26.414V24.2443V24.2422H55.2346L58.4417 27.7122L55.0925 31.2011H47.8848V28.8324H54.3108V26.414H47.8848ZM16.0781 21.7812H20.4459L25.4107 33.0134V21.7812H30.1954L34.0301 29.8346L37.5642 21.7812H42.3251V33.667H39.4282L39.4046 24.3534L35.1812 33.667H32.5899L28.3429 24.3534V33.667H22.3834L21.2536 31.0024H15.1496L14.0221 33.6647H10.8291L16.0781 21.7812ZM16.1924 28.5398L18.2034 23.793L20.2121 28.5398H16.1924Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.02b50ca4626d9088471eff5365fffd97.svg";
export { ForwardRef as ReactComponent };